import service from "@/store/services/event-time-slots-service";
import Jsona from "jsona";

const jsona = new Jsona();

export const state = () => ({
  list: {},
  eventTimeSlot: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, eventTimeSlot) => {
    state.eventTimeSlot = eventTimeSlot;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((eventTimeSlot) => {
      commit("SET_RESOURCE", eventTimeSlot);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((eventTimeSlot) => {
      commit("SET_RESOURCE", eventTimeSlot);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((eventTimeSlot) => {
      commit("SET_RESOURCE", eventTimeSlot);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },

  getAttendeesReport({ commit, dispatch }, params) {
    return service.getAttendeesReport(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  eventTimeSlot: (state) => state.eventTimeSlot,
  url: (state) => state.url,
};

const eventTimeSlots = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default eventTimeSlots;
